export default "__VITE_PUBLIC_ASSET__086210fb__"